import { PositionedToggle, TextBase } from '@carboncopyco/ui';
import { useDemoLinkEnabled } from './DemoLinkModalContext';

export const DemoLinkEnable = ({ disabled }: { disabled?: boolean }) => {
  const [enabled, setEnabled] = useDemoLinkEnabled();
  return (
    <div className="w-full">
      <div className="flex items-center gap-2">
        <PositionedToggle
          name="enabled"
          checked={enabled}
          onChange={() => setEnabled(!enabled)}
          disabled={disabled}
          testId="internal-link-enabled-toggle"
        />
        <TextBase
          label={`Link ${enabled ? 'active' : 'inactive'}`}
          color="text-ds-natural-600"
        />
      </div>
    </div>
  );
};
